import { render, staticRenderFns } from "./PrivateFilesOnContactPage.vue?vue&type=template&id=1565558b&scoped=true&"
import script from "./PrivateFilesOnContactPage.vue?vue&type=script&lang=js&"
export * from "./PrivateFilesOnContactPage.vue?vue&type=script&lang=js&"
import style0 from "./PrivateFilesOnContactPage.vue?vue&type=style&index=0&id=1565558b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1565558b",
  null
  
)

export default component.exports